export default __webpack_public_path__ + "static/media/Q10.364800a7.jpg";